import React, { Component } from 'react';
import Headroom from 'react-headroom';
import { Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem, NavLink } from 'reactstrap';
import { Button } from 'reactstrap';
class HeaderMenu extends Component {
  state = {
      isOpen: false
    }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }
  render() {
    return (
      <Headroom>
      <div>
        <Navbar color="faded" light toggleable>
          <NavbarToggler right onClick={this.toggle.bind(this)} />
          <NavbarBrand href="/">friendisor</NavbarBrand>
          <Collapse isOpen={this.state.isOpen} navbar>
            <Nav className="ml-auto" navbar>
              <NavItem>
                <NavLink onClick={this.props.scrollToSocialWall}>Get Started</NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="https://github.com/reactstrap/reactstrap">Sign In</NavLink>
              </NavItem>
            </Nav>
          </Collapse>
        </Navbar>
      </div>
      </Headroom>
    );
  }
}

export { HeaderMenu };



/** WEBPACK FOOTER **
 ** ./src/common/HeaderMenu.js
 **/